import { IconButton, Tooltip } from "@mui/material";
import Diversity3Icon from "@mui/icons-material/Diversity3";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
const CustomAgencyIcon = ({ ...props }) => {
  const color = props?.color || "#1976d2";
  const size = props?.size || "22px";
  const fileSrc = "/public/icon/action-edit.svg";

  return (
    <Tooltip title={props?.label || "Agency"} placement="left" arrow>
      <IconButton {...props}>
        {/* <div
          style={{
            width: size,
            height: size,
            // marginLeft: "10px",
            display: "inline-block",
            verticalAlign: "middle",
            backgroundColor: color,
            maskImage: "url(" + fileSrc + ")",
            maskSize: "contain",
            WebkitMaskImage: "url(" + fileSrc + ")",
            WebkitMaskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskRepeat: "no-repeat",
          }}
        /> */}
        <PeopleOutlineIcon
          style={{ color: color, width: size, height: size }}
        />
      </IconButton>
    </Tooltip>
  );
};

export default CustomAgencyIcon;
